import endOfDay from 'date-fns/endOfDay';

export const getEndOfDay = (day = new Date()) => endOfDay(day);
